const FEMALE_IMAGE_BY_AGE = {
    "16-29": "/static/image/questionnaire/fasting/gender/GenderFemale20.png",
    "30-39": "/static/image/questionnaire/fasting/gender/GenderFemale40.png",
    "40-49": "/static/image/questionnaire/fasting/gender/GenderFemale40.png",
    "50+": "/static/image/questionnaire/fasting/gender/GenderFemale60.png",
    default: "/static/image/questionnaire/fasting/gender/GenderFemale40.png"
};

const MALE_IMAGE_BY_AGE = {
    "16-29": "/static/image/questionnaire/fasting/gender/GenderMale20.png",
    "30-39": "/static/image/questionnaire/fasting/gender/GenderMale40.png",
    "40-49": "/static/image/questionnaire/fasting/gender/GenderMale40.png",
    "50+": "/static/image/questionnaire/fasting/gender/GenderMale60.png",
    default: "/static/image/questionnaire/fasting/gender/GenderMale40.png"
};

const FEMALE_AUDIENCE_BY_AGE = {
    "16-29": "women in their 20s",
    "30-39": "women in their 30s",
    "40-49": "women in their 40s",
    "50+": "women over 50",
    default: "women like you"
};

const MALE_AUDIENCE_BY_AGE = {
    "16-29": "men in their 20s",
    "30-39": "men in their 30s",
    "40-49": "men in their 40s",
    "50+": "men over 50",
    default: "men like you"
};

const NEUTRAL_AUDIENCE_BY_AGE = {
    "16-29": "people in their 20s",
    "30-39": "people in their 30s",
    "40-49": "people in their 40s",
    "50+": "people over 50",
    default: "people like you"
};

export const getFastingGenderImage = (gender, ageRange) => {
    const imageMap = gender === "male" ? MALE_IMAGE_BY_AGE : FEMALE_IMAGE_BY_AGE;
    return imageMap[ageRange] || imageMap.default;
};

export const getFastingAudienceText = (gender, ageRange) => {
    const audienceMap = gender === "male"
        ? MALE_AUDIENCE_BY_AGE
        : gender === "female"
            ? FEMALE_AUDIENCE_BY_AGE
            : NEUTRAL_AUDIENCE_BY_AGE;
    return audienceMap[ageRange] || audienceMap.default;
};
